module.exports = __webpack_public_path__ + "static/media/teuCred_bankings.b458cebc.png";